'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setPlayingIndex;

var _store = require('../../../store');

var _store2 = _interopRequireDefault(_store);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setPlayingIndex(playerId, playingIndex) {
  var player = _store2.default.getPlayerInstance(playerId);

  if (player && player.playingIndex !== playingIndex) {
    player.playingIndex = playingIndex;
  }

  return {
    type: _constants.SET_PLAYING_INDEX,
    playingIndex: playingIndex,
    playerId: playerId
  };
}
module.exports = exports['default'];